import { AxiosHelper } from "../axiosConfig";
import APIConstant from "../utils/apiConstant";

export const getAcademicsActivities = (activty) => {
  return AxiosHelper.axiosInstance().get(APIConstant.CMS_ACADEMICSACTIVITY, {
    params: {
      AcademicsActivityId: activty.bundleId,
      ActivtyName: activty.bundleName,
      OrderByColumn: activty.orderByColumn,
      SortDir: activty.sortByDesc,
      isActive: activty.isActive,
      PageSize: activty.pageSize,
      PageNumber: activty.pageNumber,
    },
  });
};

export const postAcademicsActivity = (activity) => {
  return AxiosHelper.axiosInstance().post(
    APIConstant.CMS_ACADEMICSACTIVITY,
    activity,
    {}
  );
};
